import { createReducer } from "@reduxjs/toolkit";
import { resetSendUserInvitation, sendUserInvitation } from "./send-user-invitation";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const sendUserInvitationReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(sendUserInvitation.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(sendUserInvitation.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(sendUserInvitation.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetSendUserInvitation, () => {
    return initialState;
  });
});
